// extracted by mini-css-extract-plugin
module.exports = {"main":"GetPositionButton_main__1NqcS"};